import { useMutation } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
export var useInitRefresh = function (_a) {
    var listId = _a.listId, onSuccess = _a.onSuccess, onError = _a.onError;
    var ky = useOkapiKy();
    var _b = useMutation(function () { return ky.post("lists/".concat(listId, "/refresh")).json(); }, {
        retry: false,
        onSuccess: function (data) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
            reset();
        },
        onError: function (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
            reset();
        }
    }), initRefresh = _b.mutate, reset = _b.reset, isLoading = _b.isLoading;
    return {
        initRefresh: initRefresh,
        reset: reset,
        initRefreshInProgress: isLoading
    };
};
